import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const ServiceCard = ({ service, index }) => {
  const IconComponent = service.icon;
  const [imageLoadError, setImageLoadError] = useState(false);
  const isPestControl = service.slug === 'pest-control-brisbane';
  const title = service.displayName || service.name;

  const renderFeatureText = (feature) => {
    if (Array.isArray(feature)) {
      return feature.map((item, index) => (
        <React.Fragment key={`${feature}-${index}`}>{item}</React.Fragment>
      ));
    }

    if (React.isValidElement(feature)) {
      return feature;
    }

    return <span>{feature}</span>;
  };

  return (
    <div
      className="card group relative p-6 md:p-8 border border-gray-100 hover:border-primary-200 transition-all duration-300"
    >
      {isPestControl ? (
        <span className="absolute right-4 top-4 z-10 inline-flex items-center rounded-full bg-accent-500 px-3 py-1 text-[11px] font-semibold tracking-wide text-white shadow-sm">
          Most Booked
        </span>
      ) : null}

      {/* Preview image */}
      {service.image && !imageLoadError ? (
        <div className="mb-5 overflow-hidden rounded-xl">
          <img
            src={service.image}
            alt={title}
            className="h-44 w-full object-cover"
            loading="lazy"
            onError={() => setImageLoadError(true)}
          />
        </div>
      ) : (
        <div className="w-14 h-14 bg-primary-50 rounded-xl flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors duration-300">
          <IconComponent className="text-2xl text-primary-500 group-hover:text-white transition-colors duration-300" />
        </div>
      )}

      {/* Title */}
      <h3 className="text-lg font-heading font-semibold text-gray-800 mb-3">
        {title}
      </h3>

      {/* Description */}
      <p className="text-gray-500 text-sm leading-relaxed mb-5">
        {service.shortDescription}
      </p>

      {/* Features preview */}
      {service.features && (
        <ul className="space-y-2 mb-6">
          {service.features.slice(0, 3).map((feature, index) => (
            <li key={`${service.slug}-${index}`} className="flex items-center gap-2 text-sm text-gray-600">
              <span className="w-1.5 h-1.5 bg-accent-500 rounded-full flex-shrink-0" />
              {renderFeatureText(feature)}
            </li>
          ))}
        </ul>
      )}

      {/* CTA */}
      <Link
        to={`/services/${service.slug}`}
        className="inline-flex items-center gap-2 text-primary-500 font-semibold text-sm hover:text-accent-500 transition-colors group/link"
      >
        View Service Details
        <FaArrowRight className="text-xs group-hover/link:translate-x-1 transition-transform" />
      </Link>
    </div>
  );
};

export default ServiceCard;